import { HashRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Header from "@Header";
import Footer from "@Footer";
import EmptyFooter from "../Footer/EmptyFooter";
import Toast from "@Comp/Toast";
import routesJson from '@LayOut/Routes/Routes.json'
import React, { Suspense, useEffect, useRef, useState } from 'react';
import ReactGa from 'react-ga4';

import Main from '@App/Main/Main';
import Login from '@App/Login/Login';
import SignIn from '@Views/app/SignIn/SignIn';
import ECOSHelp from '@Views/app/CustomerSupport/ECOSHelp';
import Search from '@Views/app/Main/Search';
import { getLanguage, isEmpty } from '@Views/utils/StringUtils';
import NotFound from './NotFound';
import SiteLink from '@Views/app/SiteLink/SiteLink';
import Profile from '@Views/app/SignIn/Profile';
import PasswordFind from '@Views/app/Login/comp/PasswordFind';
import IdFind from '@Views/app/Login/comp/IdFind';
import ShortLink from '@Views/app/Main/ShortLink';
import CSISurvey from '@Views/app/CustomerSupport/CSISurvey';

const Body = ({ userInfo, getMsg, setUserInfo }: any) => {
  const history = useHistory();
  const bodyRef = useRef<any>();

  const getRoute = () => {

    if (window.location.href.indexOf('boknet.intra') !== -1) {
      history.push({ pathname: '/SearchStat', state: null });
    }

    const result: any = [];
    const json: any = routesJson;
    const language = getLanguage();

    for (const key of Object.keys(json)) {

      const href = json[key]['href'];
      if (!href) {
        const url = json[key]['url'];
        const params = json[key]['params'];
        const subMenu = json[key]['menu'];

        if (subMenu) {

          for (const item of subMenu) {
            const menuUrl = url + '/' + item['url'];
            const Comp = React.lazy(() => import('@Views/app/' + menuUrl));
            const path = '/' + menuUrl;

            if (item['lang'].indexOf(language) === -1) {
              continue;
            }

            if (item['params']) {
              for (const param of item['params']) {
                const paramPath = path + param;
                result.push(<Route exact key={paramPath} path={paramPath} render={() => <Comp url={menuUrl} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
              }
            }

            result.push(<Route key={path} exact path={path} render={() => <Comp url={menuUrl} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
          }
        } else {
          const Comp = React.lazy(() => import('@Views/app/' + url + '/' + url));
          const menuUrl = url + '/' + url;
          const path = '/' + url;

          if (json[key]['lang'].indexOf(language) === -1) {
            continue;
          }

          if (params) {
            for (const param of params) {
              const paramPath = path + param;
              result.push(<Route exact key={paramPath} path={paramPath} render={() => <Comp url={path} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
            }
          }

          result.push(<Route key={path} exact path={path} render={() => <Comp url={path} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
        }
      }
    }

    result.push(<Route key="Main" exact path="/" render={() => <Main url={'/'} msg={getMsg("Main/Main")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
    result.push(<Route key="Search" exact path="/Search/:text" render={() => <Search url={'/Search'} msg={getMsg("Main/Search")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
    result.push(<Route key="Short" exact path="/Short/:shortUrl" render={() => <ShortLink url={'/Short'} msg={getMsg("Main/Search")} userInfo={userInfo} />} />);
    result.push(<Route key="ECOSHelp" exact path="/ECOSHelp" render={() => <ECOSHelp url={'/ECOSHelp'} msg={getMsg("CustomerSupport/ECOSHelp")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);

    if (language === 'ko') {
      result.push(<Route key="Login" exact path="/Login" render={() => <Login url={'/Login'} msg={getMsg("Login/Login")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
      result.push(<Route key="SignIn" exact path="/SignIn" render={() => <SignIn url={'/SignIn'} msg={getMsg("SignIn/SignIn")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
      result.push(<Route key="Profile" exact path="/Profile" render={() => <Profile url={'/Profile'} msg={getMsg("SignIn/Profile")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
      result.push(<Route key="SiteLink" exact path="/SiteLink" render={() => <SiteLink url={'/SiteLink'} msg={getMsg("SiteLink/SiteLink")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
      result.push(<Route key="IdFind" exact path="/IdFind" render={() => <IdFind url={'/IdFind'} msg={getMsg("Login/Login")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
      result.push(<Route key="PasswordFind" exact path="/PasswordFind" render={() => <PasswordFind url={'/PasswordFind'} msg={getMsg("Login/Login")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
      result.push(<Route key="CSISurvey" exact path="/CSISurvey" render={() => <CSISurvey url={'/CSISurvey'} msg={getMsg("/CSISurvey")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
    }

    result.push(<Route key="NotFound" component={NotFound}></Route>);

    return result;
  }

  const bodyChange = () => {

    const hash = window.location.hash;

    if (bodyRef['current']['classList'].contains("wrap-body-visualization")) {
      bodyRef['current']['classList'].remove('wrap-body-visualization');
    }

    if (hash.indexOf('#/StatisticsByTheme/VisualStat') !== -1) {
      bodyRef['current']['classList'].add('wrap-body-visualization');
    }

    if (hash.indexOf('#/EconomicIndicatorExplanation') !== -1) {
      bodyRef['current']['classList'].add('wrap-body-visualization');
    }

  }

  useEffect(() => {
    bodyChange();

    return history.listen((location) => {

      if (window.location.href.indexOf('boknet.intra') !== -1) {
        if (location.pathname === "/") {
          history.push({ pathname: '/SearchStat', state: null });
        }
      }

      if (location.pathname === "/SearchStat") {
        if (isEmpty(location['state'])) {
          window.location.reload();
        }
      }

      bodyChange();
      if (window.location.href.indexOf('ecostest.bok.or.kr') === -1) {
        ReactGa.send({ hitType: 'pageview', path: location.pathname, location: location.pathname, title: location.pathname });
      }

    })
  }, [history])


  return <>
    <div className={"wrap-body"} ref={bodyRef}>
      <Suspense fallback={<><Loading /></>}>
        <Switch>
          {getRoute()}
        </Switch>
      </Suspense>
    </div>
  </>
}

const Loading = () => {
  return (
    <div className="loading displayNone">
      <div className="loading-visual">
        <div className="image">
          <div className="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <p className="text">Loading ...</p>
      </div>

      <div className="loading-dim"></div>
    </div>
  )
}

const Routes = () => {
  const { t } = useTranslation();
  const userInfoSession: any = sessionStorage.getItem("userInfo");
  const [userInfo, setUserInfo]: any = useState(JSON.parse(userInfoSession));

  const getMsg = (url?: string) => {
    const comMsg = { "comMsg": t("comMsg", { returnObjects: true }) };

    if (url) {
      return Object.assign(t(url, { returnObjects: true }), comMsg['comMsg']);
    } else {
      return comMsg['comMsg'];
    }
  }

  const isMobile = () => { return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent); }

  if (isMobile()) {
    window.location.href = '/mobile/';
  }

  return (
    <>
      <Toast getMsg={getMsg} />
      <Loading />
      <Router>
        <Header getMsg={getMsg} routesJson={routesJson} userInfo={userInfo} setUserInfo={setUserInfo} />
        <Body getMsg={getMsg} userInfo={userInfo} setUserInfo={setUserInfo} />
        {
          window.location.href.indexOf('boknet.intra') === -1 ?
            <Footer getMsg={getMsg} />
            :
            <EmptyFooter getMsg={getMsg} />
        }
      </Router>
    </>
  )
}


export default Routes;